import React from "react";
import { EuiDescriptionList, EuiPanel } from "@elastic/eui";
import styled from "styled-components";

const orderMaxWidth = "900px";

export const CreateOrderWrapper = styled.div`
    .create-order__header {
        max-width: ${orderMaxWidth};
        margin: 0 auto;
        padding: 0 40px;
    }

    .create-order__header-column {
        padding: 30px;
    }

    #bulk-trip-field {
        padding-top: 0;
        padding-bottom: 0;
        margin-top: 10px;
    }

    .create-order__bulk-counter {
        padding: 10px;
        align-items: center;
        background: ${(props) => props.theme.default.euiColorPrimary};
        color: #fff;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        font-size: 20px;
        position: absolute;
        transform: translate(-50%, -50%);
        top: 0;
        right: -50px;

        &,
        span {
            display: flex;
            justify-content: center;
        }

        span {
            align-items: flex-end;

            small {
                font-size: 10px;
                font-weight: 600;
            }
        }
    }

    .create-order__title {
        margin-bottom: 10px;
    }

    .create-order__submit-btn {
        min-width: 500px;
        font-weight: 600;
        padding: 25px 0;
    }

    .create-order__title--required {
        position: relative;
        display: inline-block;

        &::after {
            content: "*";
            color: red;
            font-weight: 400;
            position: absolute;
            right: -15px;
            top: 0;
        }
    }

    @media only screen and (max-width: 768px) {
        & {
            padding: 30px 5px 15px 5px;
        }

        .create-order__header {
            padding: 0 20px;
            max-width: 100%;
        }

        .create-order__header-column {
            padding: 0;
        }

        .create-order__bulk-counter {
            right: 0;
            transform: translate(0, -50%);
        }

        #organization-column {
            border-right: none;
        }

        .create-order__submit-btn {
            min-width: 100%;
        }
    }
`;

export const TripFormWrapper = styled.div`
    .euiDescriptionList.euiDescriptionList--row
        .euiDescriptionList__title.trip-points__label--invalid {
        color: ${(props) => props.theme.default.euiColorDanger};
    }

    .form__field-wrapper {
        position: relative;
    }

    .field-wrapper__create-btn {
        position: absolute;
        right: 0;
        top: -5px;
    }
`;

export const DescriptionList = styled(({ isCentered, ...props }) => (
    <EuiDescriptionList {...props} />
))`
    ${(props) => props.isCentered && "max-width: 300px; margin: 0 auto;"}

    @media only screen and (max-width: 768px) {
        & {
            ${(props) => props.isCentered && "max-width: 100%; margin: 0 20px;"}
        }
    }
`;

export const CreateTripContainer = styled(({ ...props }) => (
    <EuiPanel
        paddingSize="none"
        {...props}
    />
))`
    margin-top: 50px;
    margin-bottom: 30px;

    position: relative;

    .create-order__create-trip-btn-wrapper {
        position: absolute;
        left: 0;
        top: 0;
        transform: translate(-50%, -50%);
        background: ${(props) => props.theme.default.euiColorLightestShade};
        border-radius: 50%;
        overflow: hidden;
    }

    .create-order__delete-trip-btn-wrapper {
        position: absolute;
        right: 30px;
        top: 30px;
        transform: translate(-50%, -50%);
    }

    .trip__form-wrapper--hidden {
        opacity: 0;
        position: absolute;
        top: 0;
        z-index: -999;
    }

    .create-order__trips-pagination {
        position: absolute;
        top: 0;
        left: 50px;
        transform: translate(0, -50%);

        & > button {
            display: none;
        }

        button.euiPaginationButton {
            margin-inline-end: 5px;
            width: 25px;
            height: 25px;
            font-size: 12px;
            font-weight: 600;
            border-radius: 50%;
            background: ${(props) => props.theme.default.euiColorMediumShade};
            color: ${(props) => props.theme.default.euiColorFullShade};

            span {
                padding: 0;
            }

            &.euiPaginationButton-isActive {
                background: ${(props) => props.theme.default.euiColorPrimary};
                color: #fff;
            }

            &.invalid {
                color: #bd271e;
                background-color: #f8e9e9;
            }
        }
    }

    h3 {
        margin-bottom: 30px;
        font-size: 18px;
        font-weight: 600;
    }

    .create-order__fields-wrapper {
        justify-content: space-between;
    }

    .create-order__section {
        max-width: ${orderMaxWidth};
        margin: 0 auto;
        padding-top: 120px;
    }

    .create-order__sub-section {
        width: 50%;
    }

    .create-order__section,
    .create-order__sub-section {
        padding: 70px;
    }

    .border-right {
        border-right: 1px solid ${(props) => props.theme.default.euiColorLightShade};
    }

    .trip-points__input {
        overflow: auto;
    }

    @media only screen and (max-width: 768px) {
        & {
            margin-bottom: 15px;
        }

        .create-order__create-trip-btn-wrapper,
        .create-order__delete-trip-btn-wrapper {
            transform: translate(0%, -50%);
        }

        .create-order__delete-trip-btn-wrapper {
            right: 20px;
        }

        .create-order__trips-pagination {
            left: 65px;
        }

        .create-order__section,
        .create-order__sub-section {
            padding: 35px 20px;
        }

        h3 {
            margin-bottom: 20px;
        }

        .border-right {
            border-right: none;
            border-bottom: 1px solid ${(props) => props.theme.default.euiColorLightShade};
        }
    }

    @media only screen and (max-width: 767px) {
        .euiPagination__list,
        .euiPaginationButton-isPlaceholder,
        .euiPaginationButton--hideOnMobile,
        .euiPagination__list {
            display: flex;
        }
    }

    .create-order__title--required {
        position: relative;
        display: inline-block;

        &::after {
            content: "*";
            color: red;
            font-weight: 400;
            position: absolute;
            right: -15px;
            top: 0;
        }
    }

    @media only screen and (max-width: 768px) {
        & {
            padding: 30px 5px 15px 5px;
        }
        .create-order__submit-btn {
            min-width: 100%;
        }
    }
`;
